import { useMemo } from 'react';
import { useCurrentUser } from '../services/userHooks';
import type { Tag } from '../types/api';

export function useTagBySlug(slug: string): Tag | undefined {
  const { currentUser } = useCurrentUser();

  return useMemo(() => {
    if (!currentUser?.tags || !slug) return undefined;
    return currentUser.tags.find((tag) => tag.slug === slug);
  }, [currentUser?.tags, slug]);
}
